import client from './client'
import type { Notification } from '@/types/notifications'

export function list(params?: Record<string, unknown>) {
  return client.get<Notification[]>('/portal/notifications', { params })
}

export function getUnreadCount() {
  return client.get<{ unread_count: number }>('/portal/notifications/unread_count')
}

export function markRead(id: string) {
  return client.patch(`/portal/notifications/${id}/read`)
}

export function markAllRead() {
  return client.post('/portal/notifications/read_all')
}
